import React from 'react'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import {  useSelector } from 'react-redux'
import SubMenuSelection from '../../components/menus/SubMenuSelection'

import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'

export default function RequestsSent() {
    const { t } = useTranslation()

    const {selection} = useSelector(state=>state.selections)



    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Configuración" />
                        <h1 className='ms-2 m-0'>{t('menus.activeSelection')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                {/* <SubMenuSelection selection={selection} section="requestsSent"/> */}
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        <div className='text-center'>{t('global.construction')}</div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}